// extracted by mini-css-extract-plugin
export default {"videoStyle":"HlsVideo_videoStyle__Sthvh","loading":"HlsVideo_loading__umW1O","error":"HlsVideo_error__hecO5"};